import { render, staticRenderFns } from "./AllowanceBreakdown.vue?vue&type=template&id=4c12fb74"
import script from "./AllowanceBreakdown.vue?vue&type=script&lang=js"
export * from "./AllowanceBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports